// @flow

/* eslint-disable import/prefer-default-export */

import type { Subject, Response, Route } from './types';

import * as redirectService from './redirect';

export const checkIsAuthorized = (
  predicate: Function,
  objectToCheckAgains: Subject,
  redirectPath: Route,
  res: Response
): boolean => {
  if (!predicate) {
    return true;
  }

  if (!predicate(objectToCheckAgains)) {
    if (res) {
      redirectService.redirectServer(redirectPath, res);
    } else {
      redirectService.redirectClient(redirectPath);
    }

    return false;
  }

  return true;
};
